export class Attachment{
    name:string;
    type:string;
    size: number;
    url:string;
    uploadedFileId:string;
}